import { render, staticRenderFns } from "./SearchTextAdmin.vue?vue&type=template&id=47bca4b2"
import script from "./SearchTextAdmin.vue?vue&type=script&lang=js"
export * from "./SearchTextAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports